module.exports = __webpack_public_path__ + "img/activity4.7bd32748.png";